import { http } from '@/network/http';
import { useQuery } from '@tanstack/react-query';

export function useAllComments(page = 1, limit = 20) {
  return useQuery({
    queryKey: ['comments', 'all', page, limit],
    queryFn: async () => {
      // Get all creator's videos, then fetch comments across them
      const videosRes = await http.get('/videos', { params: { limit: 100 } });
      const videos = videosRes.data.videos || [];

      const allComments: any[] = [];
      for (const video of videos.slice(0, 10)) {
        const commentsRes = await http.get(`/videos/${video.id}/comments`, { params: { limit: 50 } });
        const comments = commentsRes.data.comments || [];
        allComments.push(...comments.map((c: any) => ({ ...c, videoTitle: video.title, videoId: video.id })));
      }

      return {
        comments: allComments.sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()),
        total: allComments.length,
      };
    },
  });
}
